import GraphicPackingTableFilter from './graphic-packing-table-filter';

const GraphicPackingFilters = {
    Table: GraphicPackingTableFilter
};

export default GraphicPackingFilters;
